



















import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import CommentComponent from '../atoms_molecules/Comment.vue'
import CommentCreation from '../atoms_molecules/CommentCreation.vue'
import Comment, { Commentable } from '../../../api/v2/models/comment'
import ConfirmDialog from '../atoms_molecules/ConfirmDialog.vue'
import CommentForm from '../../../api/v2/forms/comment'
import api from '../../../api/v2/api'
import User from '../../models/user'
import {makeChannel, removeChannel} from '../../../../action_cable/cable'

@Component({
  components: {
    CommentComponent,
    CommentCreation,
    ConfirmDialog
  }
})
export default class CommentContainer extends Vue {
  @Prop({required: true})
  commentable: Commentable

  @Prop({ default: null })
  user: User | null

  comments: Comment[] = []
  showCommentForm = false
  channel: any = null
  $refs: {
    confirm: ConfirmDialog
  }

  async mounted() {
    await this.loadComments()
    this.createChannel()
  }

  async loadComments() {
    this.comments = await api.comment.index(this.commentable.commentableId, this.commentable.commentableType)
  }

  async createComment(newComment: string) {
    try {
      const commentForm = new CommentForm()
      commentForm.body = newComment
      commentForm.commentableId = this.commentable.commentableId
      commentForm.commentableType = this.commentable.commentableType
      await api.comment.create(commentForm)
      this.loadComments()
      this.showCommentForm = false
    } catch (e) {
    } finally {
    }
  }

  async deleteComment(commentId: number) {
    try {
      if (await (this.$refs.confirm as any).open('本当によろしいですか？')) {
        await api.comment.delete(commentId)
        this.loadComments()
      }
    } catch (e) {
    } finally {
    }
  }

  async updateComment(comment: Comment) {
    try {
      await api.comment.update(comment.id, { body: comment.body })
      comment.isEditing = false
      this.loadComments()
    } catch (e) {
    } finally {
    }
  }

  @Watch('commentable')
  onCommentableChange() {
    this.$nextTick(() =>{
      this.createChannel()
    })
  }

  createChannel() {
    removeChannel('LessonCommentChannel')

    this.channel = makeChannel(
      'LessonCommentChannel',
      async (e) => {
        await this.loadComments()
      },
      () => {
        this.channel.send({
          action: 'follow',
          data: {
            relativeable_id: this.commentable.commentableId,
            relativeable_type: this.commentable.commentableType
          }
        })
      },
    )
  }
}
